import AuthGuard from 'utils/route-guard/AuthGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
// project-imports
import MainLayout from 'layout/MainLayout';
import { lazy } from 'react';

// render - dashboard

// render - widget
const WidgetStatistics = Loadable(lazy(() => import('pages/dashboard/statistics')));
const WidgetData = Loadable(lazy(() => import('pages/widget/data')));
const Categories = Loadable(lazy(() => import('pages/dashboard/announcement/categories')));
const ViewPermission = Loadable(lazy(() => import('pages/dashboard/rolesPermissions/ViewPermision')));

// render - forms & tables

//donations
const Donations = Loadable(lazy(() => import('pages/dashboard/donation')));

//Announcement
const Announcement = Loadable(lazy(() => import('pages/dashboard/announcement')));

//Gallery
const Gallery = Loadable(lazy(() => import('pages/dashboard/gallery')));

//Message
const Message = Loadable(lazy(() => import('pages/dashboard/message')));

//Settings
const Settings = Loadable(lazy(() => import('pages/dashboard/settings')));

//ServiceTypes
const ServiceTypes = Loadable(lazy(() => import('pages/dashboard/serviceTypes')));

//roles-permissions
const RolesPermissions = Loadable(lazy(() => import('pages/dashboard/rolesPermissions')));

//Statistics
const Statistics = Loadable(lazy(() => import('pages/dashboard/statistics')));

// pages routing
const AuthLogin = Loadable(lazy(() => import('pages/auth/auth1/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/auth1/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/auth1/forgot-password')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/auth1/reset-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/auth1/check-mail')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/auth1/code-verification')));

const AuthLogin2 = Loadable(lazy(() => import('pages/auth/auth2/login2')));
const AuthRegister2 = Loadable(lazy(() => import('pages/auth/auth2/register2')));
const AuthForgotPassword2 = Loadable(lazy(() => import('pages/auth/auth2/forgot-password2')));
const AuthResetPassword2 = Loadable(lazy(() => import('pages/auth/auth2/reset-password2')));
const AuthCheckMail2 = Loadable(lazy(() => import('pages/auth/auth2/check-mail2')));
const AuthCodeVerification2 = Loadable(lazy(() => import('pages/auth/auth2/code-verification2')));

const AuthLogin3 = Loadable(lazy(() => import('pages/auth/auth3/login3')));

// render - sample page
const Landing = Loadable(lazy(() => import('pages/landing')));

const Users = Loadable(lazy(() => import('pages/dashboard/users')));

// ==============================|| MAIN ROUTES ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'widget',
          children: [
            {
              path: 'statistics',
              element: <WidgetStatistics />
            },
            {
              path: 'data',
              element: <WidgetData />
            }
          ]
        },
        {
          path: 'dashboard',
          children: [
            {
              path: 'donation',
              element: <Donations />
            },
            {
              path: 'announcement',
              element: <Announcement />
            },
            {
              path: 'announcement/categories',
              element: <Categories />
            },
            {
              path: 'gallery',
              element: <Gallery />
            },
            {
              path: 'users',
              element: <Users />
            },
            {
              path: 'message',
              element: <Message />
            },
            {
              path: 'settings',
              element: <Settings />
            },
            {
              path: 'service-types',
              element: <ServiceTypes />
            },
            {
              path: 'roles-permissions',
              element: <RolesPermissions />
            },
            {
              path: 'roles/:id',
              element: <ViewPermission />
            },
            {
              path: 'statistics',
              element: <Statistics />
            }
          ]
        }
      ]
    },
    {
      path: '/',
      element: <CommonLayout layout="landing" />,
      children: [
        {
          path: 'landing',
          element: <Landing />
        }
      ]
    },
    {
      path: '/auth',
      element: <CommonLayout />,
      children: [
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        },
        {
          path: 'login2',
          element: <AuthLogin2 />
        },
        {
          path: 'register2',
          element: <AuthRegister2 />
        },
        {
          path: 'forgot-password2',
          element: <AuthForgotPassword2 />
        },
        {
          path: 'reset-password2',
          element: <AuthResetPassword2 />
        },
        {
          path: 'check-mail2',
          element: <AuthCheckMail2 />
        },
        {
          path: 'code-verification2',
          element: <AuthCodeVerification2 />
        },
        {
          path: 'login3',
          element: <AuthLogin3 />
        }
      ]
    }
  ]
};

export default MainRoutes;
